import Chart from 'chart.js/auto';

const CREATE_COLOR = '#009900';
const HFEA_COLOR = '#FCAD99';

function positionLegends(canvas, chart, legendMap) {
    const legendItems = canvas.parentElement.querySelectorAll('[data-legend]');
    const meta = chart.getDatasetMeta(0);
    legendItems.forEach((item) => {
        var legendIndex = parseInt(item.dataset.legend, 10);
        var barIndex = legendMap.indexOf(legendIndex);
        if (barIndex === -1) return;
        var bar = meta.data[barIndex];
        if (!bar) return;
        item.style.left = bar.x + 'px';
        requestAnimationFrame(() => { item.style.opacity = '1'; });
    });
}

function createBarChart(canvas) {
    const createVal = parseFloat(canvas.dataset.create) || 0;
    const hfeaVal = parseFloat(canvas.dataset.hfea) || 0;

    var labels = [];
    var data = [];
    var colors = [];
    var legendMap = [];

    if (createVal > 0) {
        labels.push('CREATE');
        data.push(createVal);
        colors.push(CREATE_COLOR);
        legendMap.push(0);
    }
    if (hfeaVal > 0) {
        labels.push('HFEA');
        data.push(hfeaVal);
        colors.push(HFEA_COLOR);
        legendMap.push(1);
    }

    if (data.length === 0) return null;

    const minVal = Math.min.apply(null, data);
    const maxVal = Math.max.apply(null, data);
    var allAboveTen = minVal > 10;
    var yMin = allAboveTen ? 10 : 0;
    var yMax = Math.floor(maxVal / 5) * 5 + 5;
    var range = yMax - yMin;
    var stepSize = range <= 6 ? 2 : range <= 15 ? 5 : 10;

    const chart = new Chart(canvas, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: colors,
                borderWidth: 0,
                barPercentage: 0.65,
                categoryPercentage: 0.75,
                maxBarThickness: 83,
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 1.5,
            onResize(chart) {
                positionLegends(canvas, chart, legendMap);
            },
            plugins: {
                legend: { display: false },
                tooltip: { enabled: false },
            },
            scales: {
                y: {
                    beginAtZero: !allAboveTen,
                    min: yMin,
                    max: yMax,
                    grid: {
                        display: false,
                    },
                    border: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: 'Percentage %',
                        color: '#555',
                        font: { size: 12 },
                    },
                    ticks: {
                        stepSize: stepSize,
                        color: '#555',
                        font: { size: 11 },
                    },
                },
                x: {
                    grid: { display: false },
                    border: { display: false },
                    ticks: { display: false },
                },
            },
        },
        plugins: [{
            id: 'dashedGrid',
            beforeDatasetsDraw(chart) {
                const { ctx, chartArea: { left, right }, scales: { y } } = chart;
                y.ticks.forEach((tick) => {
                    const yPos = y.getPixelForValue(tick.value);
                    ctx.save();
                    ctx.beginPath();
                    ctx.setLineDash([6, 4]);
                    ctx.strokeStyle = 'rgba(0, 0, 0, 0.4)';
                    ctx.lineWidth = 1;
                    ctx.moveTo(left, yPos);
                    ctx.lineTo(right, yPos);
                    ctx.stroke();
                    ctx.restore();
                });
            },
        }, {
            id: 'barLabels',
            afterDatasetsDraw(chart) {
                const { ctx } = chart;
                chart.data.datasets.forEach((dataset, datasetIndex) => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    meta.data.forEach((bar, index) => {
                        const value = dataset.data[index];
                        if (!value) return;
                        const fontSize = chart.width < 250 ? 10 : 13;
                        ctx.save();
                        ctx.fillStyle = '#ffffff';
                        ctx.font = `bold ${fontSize}px sans-serif`;
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'top';
                        ctx.fillText(value + '%', bar.x, bar.y + 8);
                        ctx.restore();
                    });
                });
            },
        }],
    });

    requestAnimationFrame(() => {
        chart.resize();
        positionLegends(canvas, chart, legendMap);
    });
    return chart;
}

function initWrapper(wrapper) {
    const buttons = wrapper.querySelectorAll('[data-tab-btn]');
    const contents = wrapper.querySelectorAll('[data-tab-content]');
    if (!buttons.length) return;

    const chartInstances = new Map();

    function initTabCharts(content) {
        content.querySelectorAll('.success-rate-chart').forEach((canvas) => {
            if (chartInstances.has(canvas)) return;
            chartInstances.set(canvas, createBarChart(canvas));
        });
    }

    function activateTab(index) {
        buttons.forEach((btn, i) => {
            if (i === index) {
                btn.classList.remove('bg-[#C7C9C8]', 'text-main');
                btn.classList.add('bg-peach', 'text-black');
            } else {
                btn.classList.remove('bg-peach', 'text-black');
                btn.classList.add('bg-[#C7C9C8]', 'text-main');
            }
        });

        contents.forEach((content, i) => {
            if (i === index) {
                content.classList.remove('hidden');
                initTabCharts(content);
            } else {
                content.classList.add('hidden');
            }
        });
    }

    buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => activateTab(i));
    });

    if (contents.length > 0) {
        initTabCharts(contents[0]);
    }
}

export function initSuccessRatesTab() {
    document.querySelectorAll('[data-success-rates-tabs]').forEach(initWrapper);
}
